import React, { useState, useEffect } from 'react'
import { graphql, useStaticQuery } from "gatsby"
import { useLocation } from '@reach/router'

import Logo from '../../../BrandLogo'
import { Container } from '../../../Container'

import './translate-header.css'

export const TranslateHeader = ({ isHeaderDark, languageSelected, languageToggle }) => {
    let data = useStaticQuery(graphql`
        query {
        allContentfulPage(
            sort: { fields: menuSequence, order: ASC }
        ) {
            nodes {
                id
                slug
                menuSequence
                pageLanguage
                pageHeaderLink
                useFirstChildLink
                isIncludedInMenu
                menuNameTranslation {
                    title
                    description {
                    description
                    }
                }
                pageTitle
                pageSubTitle
                submenuPage
                submenuSequence
                parentMenuName
                parentMenuOption
                secondaryNavigation {
                    pageTitle
                    slug
                }
            }
        }}
    `)

    const location = useLocation();
    const currentPath = location.pathname;

    const menuItems = data.allContentfulPage.nodes
    .filter(
        (page) => page.isIncludedInMenu === true && page.pageLanguage === 'Spanish'
    )
    .sort((a, b) => a.menuSequence - b.menuSequence); // Explicit sort

    const [isToggleMenu, setToggleMenu] = useState(false)

    const toggleMenu = () => {
        setToggleMenu(!isToggleMenu)
    }

    useEffect(() => {
        if (isToggleMenu) {
        document.documentElement.classList.add("html--menu-open");
        } else {
        document.documentElement.classList.remove("html--menu-open");
        }

        return () => {
        document.documentElement.classList.remove("html--menu-open");
        };
    }, [isToggleMenu]);

    console.log(menuItems)
    
    return (
        <header className={`translate-header${isToggleMenu ? ' toggle-active':''}`}>
            <Container isfluid={true}>
                <div className='flex wrap align-center justify-between'>
                    <Logo href="/es/" title="Savor Brands Logo" isDarkMode={isToggleMenu ? true : isHeaderDark ? isHeaderDark : false} />
                    <div className='navigation-items'>
                        <div className='flex align-center navigation-item-inner'>
                            {menuItems.map((item, index)=> {
                                const isActive = currentPath === item.slug || currentPath === `/${item.slug}`;
                                console.log(item?.secondaryNavigation?.[0]);

                                const customLink = item?.useFirstChildLink ? item?.secondaryNavigation?.[0].slug : item.slug
                                return(
                                    <div key={index} className={`item ${isActive ? 'active' : ''}`}>
                                        <a href={customLink}>{item.pageTitle}</a>
                                        {item?.secondaryNavigation !== null && (
                                            <div className="th-sub-navigation">
                                                <div className="th-sub-navigation-inner">
                                                    {item?.secondaryNavigation.map((subNavItem, subNavIndex) => (
                                                        <div key={subNavIndex} className='mb-10 th-sub-navigation-item'>
                                                            <a href={subNavItem.slug} key={subNavIndex} className='block'>{subNavItem.pageTitle}</a>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div className='flex gap-10 align-center th-action'>
                        <div className="language-toggle">
                            <div className="flex">
                                <button onClick={() => languageToggle('en')} className={!location.pathname.includes('/es') ? 'active' : ''}
                                > EN </button>
                                <button onClick={() => languageToggle('es')} className={location.pathname.includes('/es') ? 'active' : ''}
                                > ES </button>
                            </div>
                        </div>
                        <div className='th-burger' onClick={toggleMenu}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
            </Container>
        </header>
    )
}